const NewsNewLoading = () => {
  if (!document.querySelector('.news-new')) return;
  const wrapper = document.querySelector('.news-new__bg-wrapper');
  wrapper.classList.add('news-new__bg-wrapper--dark');

  const elems = document.querySelectorAll('.news-new__marker');

  setTimeout(() => {
    elems.forEach((elem) => {
      elem.classList.add('news-new__visible');
    });
  }, 500);
};

const NewsNewComponent = () => {
  NewsNewLoading();
};

export const NewsNew = () => {
  $(window).on('load', () => NewsNewComponent());
};
